; (function () {
  'use strict'

  angular
    .module('deskfy.arts')
    .directive('approvalListFilter', approvalListFilter)

  function approvalListFilter () {
    return {
      restrict: 'E',
      scope: true,
      templateUrl: '/arts/directives/approval-list-filter/approval-list-filter-directive.html?$$REVISION$$'
    }
  }
})()
